import { ViewModel,View, Component } from "binder"
import  { ExpanderView } from "./expander-view"
import { getAsBoolean } from "../utilities";

export class ExpanderViewModel extends Component{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.expanded = false;
    }
    GetDefaultView(): View <ViewModel> {
        return new ExpanderView();
    }
    public getTypeId(): string {
        return "VM-1F33C305-E703-4270-A544-65BBE7FD91FB"
    }

    public set expanded(v: boolean) { this._expanded = getAsBoolean(v); } public get expanded(): boolean { return this._expanded;} private _expanded: boolean;
    
    toggle() {
        this.expanded = !this.expanded;
    }
    
}
